import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { MuiTelInput } from "mui-tel-input";
import { Select, MenuItem, Checkbox, Switch } from "@mui/material";

export function setInputs(classes, inputs, errorMessages) {
  return Object.entries(inputs).map((element) => {
    let width = element[1].multiline === undefined ? 4 : 12;
    let required = element[1].required === undefined ? "" : "*";
    switch (element[1].type) {
      case "text":
        if (element[1].multiline) {
          return (
            <Grid key={element} item md={element[1].size?? 12}>
              <div className="label">{element[0] + required}:</div>
              <Box
                sx={{
                  "& .MuiTextField-root": { m: 1, width: "200px" },
                }}
              >
                <div className="multiLine">
                  <TextField
                    // placeholder="Enter your age"
                    // label={element[0]}
                    // id={element[0]}
                    name={element[0]}
                    // variant="outlined"
                    multiline
                    type={element[1].type}
                    className={classes.field}
                    value={element[1].value}
                    onChange={(e) =>
                      element[1].valueChangeHandler(
                        e,
                        element[1].parentName ?? null
                      )
                    }
                    onBlur={(e) =>
                      element[1].inputBlurHandler(
                        e,
                        element[1].parentName ?? null
                      )
                    }
                    error={element[1].hasError}
                    helperText={
                      element[1].hasError && errorMessages[element[0]]
                    }
                  />
                </div>
              </Box>
            </Grid>
          );
        } else {
          return (
            <Grid key={element} item md={element[1].size?? width}>
              <div className="label">{element[0] + required}:</div>
              {element[1].isPhone ?
                <MuiTelInput
                  name={element[0]}
                  type={element[1].type}
                  className={classes.field}
                  value={element[1].value}
                  onChange={(value, info) =>
                    element[1].valueChangeHandler(
                      {
                        type: "change",
                        target: {
                          value: value,
                          type: element[1].type,
                          name: element[0],
                        },
                      },
                      element[1].parentName ?? null
                    )
                  }
                  onBlur={(value, info) =>
                    element[1].inputBlurHandler(
                      {
                        type: "blur",
                        target: {
                          value: value,
                          type: element[1].type,
                          name: element[0],
                        },
                      },
                      element[1].parentName ?? null
                    )
                  }
                  error={element[1].hasError}
                  helperText={element[1].hasError && errorMessages[element[0]]}
                  defaultCountry="IT"
                  preferredCountries={["IT"]}
                  langOfCountryName="it"
                />
                : (
                  <TextField
                    // placeholder="Enter your age"
                    // label={element[0]}
                    // id={element[0]}
                    // variant="outlined"
                    name={element[0]}
                    type={element[1].type}
                    className={classes.field}
                    value={element[1].value}
                    onChange={(e) =>
                      element[1].valueChangeHandler(
                        e,
                        element[1].parentName ?? null
                      )
                    }
                    onBlur={(e) =>
                      element[1].inputBlurHandler(
                        e,
                        element[1].parentName ?? null
                      )
                    }
                    error={element[1].hasError}
                    helperText={element[1].hasError && errorMessages[element[0]]}
                  />
                )}
            </Grid>
          );
        }
      case "select":
        return (
          <Grid key={element} item md={element[1].size??width}>
            <FormControl error={element[1].hasError}>
              <div className="label">{element[0] + required}:</div>
              <Select
                name={element[0]}
                className={classes.field}
                value={element[1].value}
                onChange={(e) =>
                  element[1].conditionSelect
                    ? element[1].conditionSelectChangeHandler(
                      {
                        type: "change",
                        target: {
                          value: e.target.value.toString(),
                          type: e.target.type,
                          name: e.target.name,
                        },
                      },
                      element[1].valueChangeHandler
                    )
                    : element[1].valueChangeHandler(
                      {
                        type: "change",
                        target: {
                          value: e.target.value.toString(),
                          type: e.target.type,
                          name: e.target.name,
                        },
                      },
                      element[1].parentName ?? null
                    )
                }
                onBlur={
                  (e) => false
                  // element[1].inputBlurHandler({
                  //   type: "blur",
                  //   target: {
                  //     value: e.target.value,
                  //     type: e.target.type,
                  //     name: e.target.name,
                  //   },
                  // })
                }
                error={element[1].hasError}
              // helperText={element[1].hasError && errorMessages[element[0]]}
              >
                <MenuItem value="">Select type</MenuItem>

                {element[1].enum.map((item) => (
                  <MenuItem key={item.id} value={item.value ?? item.id}>
                    {" "}
                    {item.name}{" "}
                  </MenuItem>
                ))}
              </Select>
              {element[1].hasError && (
                <FormHelperText>{errorMessages[element[0]]}</FormHelperText>
              )}
            </FormControl>
          </Grid>
        );
      case "checkbox":
        return (
          <Grid key={element} item md={element[1].size??2}>
            <FormControl error={element[1].hasError}>
              <div className="label">{element[0] + required}:</div>
              <Checkbox
                checked={element[1].checked}
                name={element[0]}
                // className={classes.field}
                value={element[1].value}
                onChange={(e) => {
                  console.error('error', e);
                  element[1].conditionCheckbox
                    ? element[1].conditionCheckboxChangeHandler(
                      e,
                      element[1].valueChangeHandler
                    )
                    : element[1].valueChangeHandler(
                      e,
                      element[1].parentName ?? null
                    )
                }

                }
                inputProps={{ "aria-label": "controlled" }}

              // onBlur={element[1].inputBlurHandler(e, element[1].parentName ?? null)}
              // error={element[1].hasError}
              />
              {element[1].hasError && (
                <FormHelperText>{errorMessages[element[0]]}</FormHelperText>
              )}
            </FormControl>
          </Grid>
        );
      case "switch":
        return (
          <Grid key={element} item md={element[1].size??width}>
            <div className="label">{element[0] + required}:</div>
            <Switch
              checked={element[1].checked}
              name={element[0]}
              className={classes.field}
              value={element[1].value}
              onChange={(e) =>
                element[1].valueChangeHandler(e, element[1].parentName ?? null)
              }
              // onBlur={element[1].inputBlurHandler(e, element[1].parentName ?? null)}
              error={element[1].hasError}
            />
            {element[1].hasError && (
              <FormHelperText>{errorMessages[element[0]]}</FormHelperText>
            )}
          </Grid>
        );
      default:
        if (element[1].type !== undefined) {
          return (
            <Grid key={element} item md={element[1].size??width}>
              <div className="label">{element[0] + required}:</div>
              <TextField
                name={element[0]}
                type={element[1].type}
                className={classes.field}
                value={element[1].value}
                onChange={(e) =>
                  element[1].valueChangeHandler(
                    e,
                    element[1].parentName ?? null
                  )
                }
                onBlur={(e) =>
                  element[1].inputBlurHandler(e, element[1].parentName ?? null)
                }
                error={element[1].hasError}
                helperText={element[1].hasError && errorMessages[element[0]]}
              />
            </Grid>
          );
        }
        return null;
    }
  });
}
